export default "__VITE_ASSET__3AIvpc0H__"